"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Divider = _interopRequireDefault(require("@eig-builder/core-ui/Divider"));

var _getClassNameHelper = _interopRequireDefault(require("./../helpers/get-class-name-helper"));

var DrawerMainMenuDivider = function DrawerMainMenuDivider(props) {
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: (0, _getClassNameHelper["default"])('nav-item', props)
  }, /*#__PURE__*/_react["default"].createElement(_Divider["default"], null));
};

var _default = DrawerMainMenuDivider;
exports["default"] = _default;